import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './header-v2.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
import * as $ from 'jquery';
var HeaderV2 = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderV2, _super);
    function HeaderV2(element) {
        var _this = _super.call(this, element) || this;
        _this.open = false;
        _this.accountOpen = false;
        _this.activeItem = '';
        _this.activeSecondaryItem = '';
        _this.activeTertiaryItem = '';
        _this.expanded = false;
        _this.header = element;
        return _this;
    }
    HeaderV2.prototype.init = function () {
        this.accountMenu = $('.header-v2__secondary-bar-login');
        this.accountMobileMenu = $('.header-v2__mobile-menu-user');
        this.accountDesktopMenu = $('.header-v2__mobile-menu-user');
        this.hamburger = $('.js-hamburger');
        this.mobileMenu = $('.header-v2__mobile-menu');
        this.megaNavTab = $('.header-v2__mega-menu-nav-item');
        this.mobileAccountMenu = $('.header-v2__mobile-menu-account');
        this.mobileMenuNav = $('.header-v2__mobile-menu-nav');
        this.mobileMenuNavItem = $('.header-v2__mobile-menu-nav-item');
        this.mobileMenuNavSecondaryItem = $('.header-v2__mobile-menu-nav-secondary-item');
        this.mobileMenuNavTertiaryItem = $('.header-v2__mobile-menu-nav-tertiary-item');
        this.mobileMenuNavTertiaryBack = $('.header-v2__mobile-menu-nav-tertiary-back');
        var countrySelector = $('.country-selector').detach();
        $('.header-v2').append(countrySelector);
        this.accountOpen = false;
        // group
        this.groupCountryInitContainer = Array.from(this.element.querySelectorAll('.js-group-country-container-init'));
        this.groupCountryInitContainerNotSelected = Array.from(this.element.querySelectorAll('.js-group-country-container__notselected'));
        this.groupCountryInitContainerSelected = Array.from(this.element.querySelectorAll('.js-group-country-container__selected'));
        this.groupCountryTrigger = Array.from(this.element.querySelectorAll('.js-group-country-select'));
        this.groupCountryContainer = Array.from(this.element.querySelectorAll('.js-group-country-container'));
        this.groupCountrySelected = Array.from(this.element.querySelectorAll('.js-group-country-selected'));
        this.groupCountryWebsite = Array.from(this.element.querySelectorAll('.js-group-country-website'));
        this.groupCountryCollapse = Array.from(this.element.querySelectorAll('.header-v2__mega-menu--account__split--left .js-collapse-trigger'));
        this.groupCountryContainerLink = Array.from(this.element.querySelectorAll('.header-v2__mega-menu--account__split--container-link'));
        // language selector
        if (this.element.querySelector('.header-v2__top-bar-language')) {
            this.containerLanguagesDesktop = this.element.querySelector('.header-v2__top-bar-language');
        }
        if (this.element.querySelector('.js-language-selector-desktop')) {
            this.buttonLanguageSelectorDesktop = this.element.querySelector('.js-language-selector-desktop');
        }
        if (this.element.querySelector('.js-language-selector-button-mobile')) {
            this.mobileMenuNavLanguageSelector = this.element.querySelector('.js-language-selector-button-mobile');
        }
        if (this.element.querySelector('.header-v2__mobile-menu-language__overlay')) {
            this.mobileMenuNavLanguageOverlay = this.element.querySelector('.header-v2__mobile-menu-language__overlay');
        }
    };
    HeaderV2.prototype.bindEvents = function () {
        var _this = this;
        $('.js-country-selector-open').click(function () {
            _this.lastScrollTop = $(window).scrollTop();
            $('body').css({
                'overflow': 'hidden',
                'position': 'relative',
                'width': '100%'
            });
            $('.country-selector__modal').addClass('country-selector__modal--reveal');
        });
        $('.country-selector__close').click(function () {
            $('body').css({
                'overflow': '',
                'position': '',
                'width': ''
            });
            $(window).scrollTop(_this.lastScrollTop);
        });
        $(window).scroll(function () {
            _this.scroll();
        });
        this.hamburger.click('click', function () {
            _this.toggleMobileMenu();
            if (_this.mobileMenuNavLanguageSelector) {
                _this.mobileMenuNavLanguageSelector.classList.remove('header-v2__mobile-menu-language__button__opened');
                _this.mobileMenuNavLanguageOverlay.classList.remove('header-v2__mobile-menu-language__overlay--opened');
            }
        });
        this.accountMenu.click('click', function () {
            _this.toggleAccountMobileMenu();
        });
        this.accountMobileMenu.click('click', function () {
            _this.toggleAccountMobileMenu();
        });
        this.megaNavTab.click('click', function (event) {
            var megaNav = $(event.currentTarget).closest('.header-v2__mega-menu');
            var section = $(event.currentTarget).data('section');
            $(megaNav).find('.header-v2__mega-menu-nav-item').removeClass('header-v2__mega-menu-nav-item--active');
            $(megaNav).find('.header-v2__mega-menu-nav-content').removeClass('header-v2__mega-menu-nav-content--active');
            $(event.currentTarget).addClass('header-v2__mega-menu-nav-item--active');
            $(megaNav).find(".header-v2__mega-menu-nav-content[data-section='" + section + "']").addClass('header-v2__mega-menu-nav-content--active');
        });
        this.mobileMenuNavItem.click('click', function (event) {
            var section = $(event.currentTarget).data('accordion');
            if (_this.activeItem == section) {
                _this.activeItem = '';
                $(".header-v2__mobile-menu-nav-secondary").removeClass('header-v2__mobile-menu-nav-secondary--open');
                _this.mobileMenuNavItem.removeClass('header-v2__mobile-menu-nav-item--open');
            }
            else {
                _this.activeItem = section;
                _this.mobileMenuNavItem.removeClass('header-v2__mobile-menu-nav-item--open');
                $(event.currentTarget).addClass('header-v2__mobile-menu-nav-item--open');
                $(".header-v2__mobile-menu-nav-secondary").removeClass('header-v2__mobile-menu-nav-secondary--open');
                $(".header-v2__mobile-menu-nav-secondary[data-accordion='" + _this.activeItem + "']").addClass('header-v2__mobile-menu-nav-secondary--open');
            }
        });
        this.mobileMenuNavSecondaryItem.click('click', function (event) {
            var section = $(event.currentTarget).data('accordion');
            if ($(event.currentTarget).hasClass('header-v2__mobile-menu-nav-secondary-item--expanded')) {
                $(".header-v2__mobile-menu-nav-item").removeClass('header-v2__mobile-menu-nav-item--hide');
                $(event.currentTarget).removeClass('header-v2__mobile-menu-nav-secondary-item--expanded');
                $(".header-v2__mobile-menu-nav-tertiary").removeClass('header-v2__mobile-menu-nav-tertiary-item--activemenu');
                _this.mobileMenuNavTertiaryItem.removeClass('header-v2__mobile-menu-nav-tertiary-item--open');
                $(".header-v2__mobile-menu-nav-quaternary").removeClass('header-v2__mobile-menu-nav-quaternary--open');
            }
            if (_this.activeSecondaryItem == section) {
                _this.activeSecondaryItem = '';
                $(".header-v2__mobile-menu-nav-secondary").removeClass('header-v2__mobile-menu-nav-tertiary--open');
                _this.mobileMenuNavSecondaryItem.removeClass('header-v2__mobile-menu-nav-secondary-item--open');
                $(".header-v2__mobile-menu-nav-tertiary").removeClass('header-v2__mobile-menu-nav-tertiary--open');
            }
            else {
                _this.activeSecondaryItem = section;
                _this.mobileMenuNavSecondaryItem.removeClass('header-v2__mobile-menu-nav-secondary-item--open');
                $(event.currentTarget).addClass('header-v2__mobile-menu-nav-secondary-item--open');
                $(".header-v2__mobile-menu-nav-tertiary").removeClass('header-v2__mobile-menu-nav-tertiary--open');
                $(".header-v2__mobile-menu-nav-tertiary[data-accordion='" + _this.activeSecondaryItem + "']").addClass('header-v2__mobile-menu-nav-tertiary--open');
                //$(".header-v2__mobile-menu-nav-tertiary[data-accordion='" + this.activeSecondaryItem + "'] .header-v2__mobile-menu-nav-tertiary-item").first().addClass('header-v2__mobile-menu-nav-tertiary-item--open');
                //$(".header-v2__mobile-menu-nav-tertiary[data-accordion='" + this.activeSecondaryItem + "'] .header-v2__mobile-menu-nav-quaternary").first().addClass('header-v2__mobile-menu-nav-quaternary--open');				
                //$(".header-v2__mobile-menu-nav-tertiary[data-accordion='" + this.activeSecondaryItem + "'] .header-v2__mobile-menu-nav-tertiary-item").first().click();				
                $(".header-v2__mobile-menu__content").addClass('header-v2__mobile-menu__content--expanded');
            }
        });
        this.mobileMenuNavTertiaryItem.click('click', function (event) {
            event.stopImmediatePropagation();
            var section = $(event.currentTarget).data('accordion');
            $(".header-v2__mobile-menu-nav-item").addClass('header-v2__mobile-menu-nav-item--hide');
            // $(".header-v2__mobile-menu-top").hide();
            if (_this.activeTertiaryItem == section) {
                _this.activeTertiaryItem = '';
                $(".header-v2__mobile-menu-nav-tertiary").removeClass('header-v2__mobile-menu-nav-tertiary-item--activemenu');
                _this.mobileMenuNavTertiaryItem.removeClass('header-v2__mobile-menu-nav-tertiary-item--open');
                $(".header-v2__mobile-menu-nav-quaternary").removeClass('header-v2__mobile-menu-nav-quaternary--open');
            }
            else {
                _this.activeTertiaryItem = section;
                _this.mobileMenuNavTertiaryItem.removeClass('header-v2__mobile-menu-nav-tertiary-item--open');
                $(".header-v2__mobile-menu-nav-tertiary").addClass('header-v2__mobile-menu-nav-tertiary-item--activemenu');
                $(event.currentTarget).addClass('header-v2__mobile-menu-nav-tertiary-item--open');
                $('.header-v2__mobile-menu-nav-secondary-item--open').addClass('header-v2__mobile-menu-nav-secondary-item--expanded');
                $(".header-v2__mobile-menu-nav-quaternary").removeClass('header-v2__mobile-menu-nav-quaternary--open');
                $(".header-v2__mobile-menu-nav-quaternary[data-accordion='" + _this.activeTertiaryItem + "']").addClass('header-v2__mobile-menu-nav-quaternary--open');
            }
        });
        this.mobileMenuNavTertiaryBack.click('click', function (event) {
            event.stopImmediatePropagation();
            event.preventDefault();
            _this.activeSecondaryItem = '';
            _this.activeTertiaryItem = '';
            // $(".header-v2__mobile-menu-top").show();
            $(".header-v2__mobile-menu__content").removeClass('header-v2__mobile-menu__content--expanded');
            $(".header-v2__mobile-menu-nav-item").removeClass('header-v2__mobile-menu-nav-item--hide');
            $(".header-v2__mobile-menu-nav-secondary").removeClass('header-v2__mobile-menu-nav-tertiary--open');
            _this.mobileMenuNavSecondaryItem.removeClass('header-v2__mobile-menu-nav-secondary-item--open');
            _this.mobileMenuNavSecondaryItem.removeClass('header-v2__mobile-menu-nav-secondary-item--expanded');
            $(".header-v2__mobile-menu-nav-tertiary").removeClass('header-v2__mobile-menu-nav-tertiary--open');
            $(".header-v2__mobile-menu-nav-tertiary").removeClass('header-v2__mobile-menu-nav-tertiary--open');
            _this.mobileMenuNavTertiaryItem.removeClass('header-v2__mobile-menu-nav-tertiary-item--open');
            $(".header-v2__mobile-menu-nav-quaternary").removeClass('header-v2__mobile-menu-nav-quaternary--open');
        });
        // group
        if (this.groupCountryTrigger) {
            this.groupCountryTrigger.map(function (item) { return item.addEventListener('click', function (event) {
                // change styling if country is selected
                _this.groupCountryInitContainer.map(function (container) {
                    _this.accountOpen = false;
                    container.classList.remove('header-v2__mega-menu--account__split--white');
                    container.classList.add('header-v2__mega-menu--account__split');
                });
                _this.groupCountryInitContainerNotSelected.map(function (container) {
                    container.classList.add('d-none');
                });
                _this.groupCountryInitContainerSelected.map(function (container) {
                    container.classList.remove('d-none');
                });
                // selected element
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var getCountry = element.getAttribute('data-country');
                var getCountryUrl = element.getAttribute('data-link');
                var getHTML = element.outerHTML;
                getHTML = getHTML.replace('header-v2__mega-menu--account__split--countries', 'header-v2__mobile-menu-account__split--country-selected');
                // change website link
                _this.groupCountryWebsite.map(function (link) {
                    link.setAttribute('href', getCountryUrl);
                });
                // get element html
                _this.groupCountrySelected.map(function (container) {
                    container.innerHTML = getHTML;
                });
                // show relevant container
                _this.groupCountryContainer.map(function (container) {
                    container.classList.add('d-none');
                    var getCountryContainer = container.getAttribute('data-country');
                    if (getCountryContainer === getCountry) {
                        container.classList.remove('d-none');
                    }
                });
                // remove relevant button once selected
                _this.groupCountryTrigger.map(function (trigger) {
                    var closestContainer = trigger.closest('div');
                    var getCountryContainer = trigger.getAttribute('data-country');
                    // if(closestContainer){
                    // 	if(getCountryContainer === getCountry){
                    // 		closestContainer.classList.add('d-none');
                    // 	}else{
                    // 		closestContainer.classList.remove('d-none');
                    // 	}
                    // }
                });
                // collapse countries
                if (!element.classList.contains('js-initial-load')) {
                    _this.groupCountryCollapse.map(function (trigger) {
                        trigger.click();
                    });
                }
                _this.groupCountryContainerLink.map(function (item) {
                    var newComponent = document.createElement('div');
                    newComponent.classList.add('header-v2__animate-new-country');
                    item.appendChild(newComponent);
                    setTimeout(function () {
                        $('div.header-v2__animate-new-country').remove();
                    }, 600);
                });
            }); });
        }
        if (this.mobileMenuNavLanguageSelector) {
            this.mobileMenuNavLanguageSelector.addEventListener('click', function (event) {
                if (_this.mobileMenuNavLanguageSelector.classList.contains('header-v2__mobile-menu-language__button__opened')) {
                    _this.mobileMenuNavLanguageSelector.classList.remove('header-v2__mobile-menu-language__button__opened');
                    _this.mobileMenuNavLanguageOverlay.classList.remove('header-v2__mobile-menu-language__overlay--opened');
                }
                else {
                    _this.mobileMenuNavLanguageSelector.classList.add('header-v2__mobile-menu-language__button__opened');
                    _this.mobileMenuNavLanguageOverlay.classList.add('header-v2__mobile-menu-language__overlay--opened');
                }
            });
        }
        if (this.buttonLanguageSelectorDesktop) {
            this.buttonLanguageSelectorDesktop.addEventListener('click', function (event) {
                if (_this.containerLanguagesDesktop.classList.contains('header-v2__top-bar-language__opened')) {
                    _this.containerLanguagesDesktop.classList.remove('header-v2__top-bar-language__opened');
                }
                else {
                    _this.containerLanguagesDesktop.classList.add('header-v2__top-bar-language__opened');
                }
            });
        }
    };
    HeaderV2.prototype.scroll = function () {
        if ($(window).scrollTop() > 20) {
            $('.header-v2').addClass("header--sticky");
        }
        else {
            $('.header-v2').removeClass("header--sticky");
        }
    };
    HeaderV2.prototype.toggleMobileMenu = function () {
        this.open = !this.open;
        this.expanded = false;
        this.activeItem = '';
        this.activeSecondaryItem = '';
        this.activeTertiaryItem = '';
        this.mobileAccountMenu.removeClass("header-v2__mobile-menu-account--open");
        if (this.open) {
            this.lastScrollTop = $(window).scrollTop();
            $('body').css({
                'overflow': 'hidden',
                'position': 'relative',
                'width': '100%'
            });
            document.getElementsByClassName('main')[0].addEventListener("touchmove", this.freezeVp, false);
            if (this.accountOpen) {
                this.toggleAccountMobileMenu();
            }
            this.hamburger.addClass("header-v2__hamburger--open");
            $(this.element).addClass('header--open');
            this.mobileMenu.addClass("header-v2__mobile-menu--open");
            this.mobileMenuNav.addClass("header-v2__mobile-menu-nav--open");
        }
        else {
            $('body').css({
                'overflow': '',
                'position': '',
                'width': ''
            });
            $(window).scrollTop(this.lastScrollTop);
            document.getElementsByClassName('main')[0].removeEventListener("touchmove", this.freezeVp, false);
            $(this.element).removeClass('header--open');
            this.hamburger.removeClass("header-v2__hamburger--open");
            this.mobileMenu.removeClass("header-v2__mobile-menu--open");
            this.mobileMenuNav.removeClass("header-v2__mobile-menu-nav--open");
        }
    };
    HeaderV2.prototype.freezeVp = function (e) {
        e.preventDefault();
    };
    ;
    HeaderV2.prototype.toggleAccountMobileMenu = function () {
        if (MediaQueryService.getMediaQuery() === 'x-small') {
            $('.header-v2__mobile-menu__content').scrollTop(0);
            this.accountOpen = !this.accountOpen;
            if (this.accountOpen) {
                $(".header-v2__mobile-menu__content").addClass('header-v2__mobile-menu__content--expanded');
                this.mobileMenuNav.removeClass("header-v2__mobile-menu-nav--open");
                this.mobileAccountMenu.addClass("header-v2__mobile-menu-account--open");
            }
            else {
                $(".header-v2__mobile-menu__content").removeClass('header-v2__mobile-menu__content--expanded');
                this.mobileMenuNav.addClass("header-v2__mobile-menu-nav--open");
                this.mobileAccountMenu.removeClass("header-v2__mobile-menu-account--open");
            }
        }
        else if (MediaQueryService.getMediaQuery() === 'medium-small' || MediaQueryService.getMediaQuery() === 'small') {
            $('.header-v2__mega-menu--account').scrollTop(0);
            this.accountOpen = !this.accountOpen;
            if (this.accountOpen) {
                $(".header-v2__mega-menu--account").addClass('header-v2__mega-menu--open');
            }
            else {
                $(".header-v2__mega-menu--account").removeClass('header-v2__mega-menu--open');
            }
        }
    };
    HeaderV2.prototype.closeMobileMenu = function () {
        this.open = false;
        this.activeItem = '';
        this.activeSecondaryItem = '';
        this.activeTertiaryItem = '';
        this.expanded = false;
        this.hamburger.removeClass("header-v2__hamburger--open");
        this.mobileMenu.removeClass("header-v2__mobile-menu--open");
        this.mobileMenuNav.removeClass("header-v2__mobile-menu-nav--open");
    };
    return HeaderV2;
}(Base));
export { HeaderV2 };



//////////////////
// WEBPACK FOOTER
// ./components/header-v2/header-v2.component.ts
// module id = 345
// module chunks = 0